import * as React from 'react';
import {cn} from 'src/lib/utils';

/**
 * The inbox cards' surface: the same bordered card the rest of the app uses
 * (settings, account overview, detail sections), so list rows inside keep
 * their full contrast instead of sitting gray-on-gray. Exported for the
 * cards that lay out their own header.
 */
export const inboxCardSurface = 'bg-card border-border rounded-xl border';

/** Shared chrome for the inbox's job cards. */
export const InboxCard = ({
  title,
  meta,
  children,
  className,
}: {
  title: string;
  meta?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={cn(inboxCardSurface, 'px-4 py-1', className)}>
    <div className="flex items-baseline justify-between gap-2 py-2.5">
      <span className="text-foreground text-sm font-semibold">{title}</span>
      {meta !== undefined && (
        <span className="text-muted-foreground text-xs">{meta}</span>
      )}
    </div>
    {children}
  </div>
);

